export default __webpack_public_path__ + "static/media/levenspad_EN_gsm2.dd0872ff.png";